import { render, staticRenderFns } from "./MarkedInput.vue?vue&type=template&id=1506083e&scoped=true"
import script from "./MarkedInput.vue?vue&type=script&lang=js"
export * from "./MarkedInput.vue?vue&type=script&lang=js"
import style0 from "./MarkedInput.vue?vue&type=style&index=0&id=1506083e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506083e",
  null
  
)

export default component.exports